import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cancelInvoiceAction } from "../actions/cancelInvoice";
import { useSelector } from "react-redux";
import { invalidateAfterInvoiceChange } from "../utils/invoiceQueryInvalidation";

export const useCancelInvoiceMutation = () => {
  const queryClient = useQueryClient();
  const company = useSelector((state: any) => state.userState?.company);

  return useMutation({
    mutationFn: ({
      invoiceUid,
    }: {
      invoiceUid: string;
      billingJobEventUids?: string[];
      extraInvalidateJobEventUids?: string[];
      quoteId?: number | null;
    }) => {
      if (!company?.id) {
        throw new Error("Company ID is required");
      }
      return cancelInvoiceAction(invoiceUid, company.id);
    },
    onSuccess: (_data, variables) => {
      const jobEventUids = Array.from(
        new Set([
          ...(variables.billingJobEventUids ?? []),
          ...(variables.extraInvalidateJobEventUids ?? []),
        ]),
      );
      invalidateAfterInvoiceChange(queryClient, {
        invoiceUid: variables.invoiceUid,
        jobEventUids,
        quoteId: variables.quoteId,
      });
    },
  });
};
